var _path, _path2, _g, _path3, _g2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAusFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3289_968)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-190 0H741V600H-190V0Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3289_968",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -217,
    y: -1,
    width: 639,
    height: 301
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-216.279 -0.267578H421.595V299.732H-216.279V-0.267578Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3289_968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-216.279 -0.267578L421.595 299.732ZM421.595 -0.267578L-216.279 299.732Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-216.279 -0.267578L421.595 299.732M421.595 -0.267578L-216.279 299.732",
    stroke: "white",
    strokeWidth: 64
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3289_968",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -217,
    y: -1,
    width: 639,
    height: 301
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-216.279 -0.267578V149.732H421.595V299.732L-216.279 -0.267578ZM421.595 -0.267578H102.658V299.732H-216.279L421.595 -0.267578Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3289_968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-216.279 -0.267578L421.595 299.732ZM421.595 -0.267578L-216.279 299.732Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-216.279 -0.267578L421.595 299.732M421.595 -0.267578L-216.279 299.732",
    stroke: "black",
    strokeWidth: 42.6667
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.658 -0.267578V299.732ZM-216.279 149.732H421.595Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.658 -0.267578V299.732M-216.279 149.732H421.595",
    stroke: "white",
    strokeWidth: 106.667
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.658 -0.267578V299.732ZM-216.279 149.732H421.595Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.658 -0.267578V299.732M-216.279 149.732H421.595",
    stroke: "black",
    strokeWidth: 64
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.658 359.732L121.109 413.693L177.464 393.618L144.117 440.831L195.94 469.759L135.906 474.671L144.173 530.819L102.658 489.732L61.1437 530.819L69.4108 474.672L9.37598 469.759L61.1995 440.831L27.8517 393.618L84.2073 413.693L102.658 359.732Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M508 491L514.329 509.609L533.662 502.686L522.222 518.967L540 528.943L519.405 530.637L522.241 550L508 535.831L493.759 550L496.595 530.637L476 528.943L493.778 518.967L482.338 502.686L501.671 509.609L508 491Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M415.5 331L421.928 349.924L441.563 342.884L429.945 359.441L448 369.586L427.084 371.309L429.964 391L415.5 376.591L401.036 391L403.916 371.309L383 369.586L401.056 359.441L389.437 342.884L409.072 349.924L415.5 331Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M532 213L538.329 231.609L557.662 224.686L546.222 240.967L564 250.943L543.405 252.637L546.241 272L532 257.831L517.759 272L520.595 252.637L500 250.943L517.778 240.967L506.338 224.686L525.671 231.609L532 213Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M562.5 374L567.582 385.683L581 386.605L570.722 394.747L573.934 407L562.5 400.35L551.066 407L554.278 394.747L544 386.605L557.418 385.683L562.5 374Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3289_968"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 300C0 134.315 134.315 0 300 0V0C465.685 0 600 134.315 600 300V300C600 465.685 465.685 600 300 600V600C134.315 600 0 465.685 0 300V300Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAusFlag);
export default __webpack_public_path__ + "static/media/ausFlag.9a0b6697ba6d9669c4e9c7a7b0d30cee.svg";
export { ForwardRef as ReactComponent };